import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const FuelCellsAndSolarCells = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Fuel cells and Solar cells"
    videos={[
      "https://www.youtube.com/embed/GfJN3EMe0Jk",
      "https://www.youtube.com/embed/metos6qle_U",
      "https://www.youtube.com/embed/L9WV6hn8shY",
      "https://www.youtube.com/embed/YSRs3PuYT_k",
      "https://www.youtube.com/embed/CWEKfxBc4_8"
    ]}
    takeaways={[
      { text: "Learn all Hydrogen fuel cells." },
      { text: "Dye-sensitized solar cells are important." }
    ]}
    questions={[
      "Explain how the combination of H2 and O2 in a fuel cell leads to energy generation with diagramatic representation. Mention its applications.",
      "Identify an electrical energy source for industrial utility that uses a solid electrolyte. Describe its functioning with a diagram.",
      "The natural Betanin pigment of Beetroot is used as an important component in an energy-harvesting device. Identify the device and discuss the working mechanism with a neat diagram.",
      "Which electricity producing devices use ceramic components? Explain their function using a schematic diagram. Despite the high operating temperature, why is this energy device still preferred?",
      "Explain in detail, how the addition of dye molecule improve the conductivity of polyacetylene with a suitable mechanism."
    ]}
    exampleVideos={[]}
  />
);
}

export default FuelCellsAndSolarCells;
